<template>
	<v-footer ref="footer" id="footerContainer">
		<v-container fluid>
			<v-divider style="border-color: #009dc4;"/>
		</v-container>

		<v-container>
			<v-row justify="start">
				<v-col sm="12" md="6">
					<NewsList :news="news" />
				</v-col>
				<v-col sm="7" md="4">
					<UsefulLinks :links="links" />
				</v-col>
				<v-col sm="5" md="2">
					<v-row class="pl-4">
						<v-col cols="12">
							<a href="https://kartverket.no/en" target="_blank">
								<v-img
									src="img/kartverket_staende_web.png"
									alt="Logo - Kartverket"
									contain
								/>
							</a>
						</v-col>
						<v-col cols="12">
							<a href="https://ecc.no/" target="_blank">
								<v-img
									contain
									src="img/ecc_logo.png"
									alt="Logo - Electronic Chart Centre"
								/>
							</a>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row justify="center" class="mt-4">
				<v-col cols="auto">
					<small>Copyright ©2020, all rights reserved by respective parties.
						<a
							href="https://www.kartverket.no/en/about-kartverket/data-protection-policy"
							target="_blank"
						>
							Privacy Policy
						</a>
					</small>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
import ContentService from '@/services/ContentService'
// import api from '@/helpers/api'
// import EventBus from '@/helpers/eventbus'
import NewsList from '@/components/n-collections/NewsList'
import UsefulLinks from '@/components/n-collections/UsefulLinks'

export default {
	components: {
		NewsList,
		UsefulLinks,
	},

	data() {
		return {
			news: [],
			links: [],
		}
	},

	async created() {
		const { news, links } = await ContentService.get('home')
		this.news = news.slice().reverse()
		this.links = links
	},
}
</script>

<style lang="stylus" scoped>
#footerContainer
	background linear-gradient(180deg, rgba(0, 56, 122, 0) 0%, rgba(255, 255, 255, 0.5) 100%)
	min-height 200px

a
	text-decoration none

.socialSheet
	height 45px
	width 45px
	margin-left 10px
	padding 5px
	display inline-flex

.socialSheet .v-icon:hover
	color white !important
</style>
